export default __webpack_public_path__ + "static/media/jyoti.8cbc9a4a.jpg";